import { gql } from '@/__generated__';

const GET_COLLECTION_DEVICES = gql(`#graphql
  query CollectionsAccess_GetCollectionDevices($collectionId: Int!) {
    collection(filter: { id: $collectionId }) {
      id
      devices {
        id
        profile {
          id
          name
        }
      }
    }
  }
`);

export default GET_COLLECTION_DEVICES;
